<!-- =========================================================================================
  File Name: CashRegister.vue
  Description: CashRegister Edit Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="page-branch-edit">

    <vs-alert color="danger" title="Caja no encontrada" :active.sync="id_not_found">
      <span>Datos de caja con id {{ $route.params.id }} no encontrados. </span>
      <span>
        <span>Verifique </span><router-link :to="{name:'cash_registers'}" class="text-inherit underline"> todas las cajas</router-link>
      </span>
    </vs-alert>

    <vx-card v-show="loaded" class="mb-2">

      <div slot="no-body" class="tabs-container px-6 pt-6">
        <div class="vx-row">
          <!-- Information - Col 1 -->
          <div class="vx-col flex-1" id="account-info-col-1">
            <div class="w-full">
              <div class="w-full">
                <ejs-textbox class="e-input" type="text" floatLabelType="Auto" placeholder="Código" v-model="data_local.code" :enabled="editing"/>
              </div>
              <div class="w-full">
                <ejs-textbox class="e-input" type="text" floatLabelType="Auto" placeholder="Descripción" v-model="data_local.name" :enabled="editing"/>
              </div>
              <div class="w-full mb-2">
              </div>
              <div class="w-full">
                <ejs-dropdownlist highlight=true floatLabelType="Auto" placeholder="Bodega" :dataSource="warehouses" :fields="{text: 'name', value: 'id'}" v-model="data_local.warehouseId" :enabled="editing"/>
              </div>
              <div class="w-full">
                <ejs-dropdownlist highlight=true floatLabelType="Auto" placeholder="Estado" :dataSource="status" :fields="{text: 'value', value: 'code'}" v-model="data_local.statusId" :enabled="editing"/>
              </div>
              <div class="w-full">
                <ejs-textbox class="e-input" type="text" floatLabelType="Auto" placeholder="Comentarios" v-model="data_local.comments" :multiline="true" :enabled="editing"/>
              </div>
              <div class="w-full vx-row" v-for="item in data_local.resolutions" :key="item.code">
                <div class="vx-col w-1/5 mt-5">
                  <ejs-checkbox :label="item.name" v-model="item.availableInPOS" :checked="item.availableInPOS" :disabled="!editing"></ejs-checkbox>
                </div>
                <div class="vx-col w-4/5">
                  <ejs-dropdownlist
                    floatLabelType="Auto"
                    placeholder="Resolución"
                    highlight=true
                    v-model="item.resolutionId"
                    :dataSource="resolutions"
                    :fields="{text: 'fullName', value: 'id'}"
                    :enabled="editing && item.availableInPOS"
                    :query='resolutionQuery'
                    allowFiltering=true
                    :filtering='resolutionFiltering'
                  />
                </div>
              </div>
            </div>
          </div>

        </div>

        <div class="vx-row mt-3">
          <div class="vx-col w-full mb-4">
            <div class="flex flex-wrap items-center justify-end">
              <vs-button icon-pack="feather" icon="icon-edit" class="mr-4" v-show="!editing" @click="editing = true">Editar</vs-button>
              <vs-button type="border" color="danger" icon-pack="feather" icon="icon-trash" v-show="!editing" @click="confirmDeleteRecord">Eliminar</vs-button>
              <vs-button class="ml-auto" @click="save" v-show="editing" :disabled="!validateForm">Guardar cambios</vs-button>
              <vs-button class="ml-4 mt-2" type="border" color="warning" @click="reset_data" v-show="editing">Cancelar</vs-button>
            </div>
          </div>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
  var deltaPOS_config = require('@/deltaPOS.config.js')

  import Vue from "vue";
  import {TextBoxPlugin} from '@syncfusion/ej2-vue-inputs';
  import {DropDownListPlugin} from "@syncfusion/ej2-vue-dropdowns";
  import {CheckBoxPlugin} from "@syncfusion/ej2-vue-buttons";
  import {Query} from "@syncfusion/ej2-data";

  Vue.use(TextBoxPlugin);
  Vue.use(DropDownListPlugin);
  Vue.use(CheckBoxPlugin);

  export default {
    data() {
      return {
        loaded: false,
        editing: false,
        id: 0,
        data: null,
        status: [],
        resolutions: [],
        warehouses: [],
        resolutionQuery: new Query().select(['fullName', 'id']).take(10),
        statusFields: {text: 'value', value: 'code'},
        data_local: {
          id: 0,
          code: '',
          name: '',
          resolutions: [],
          comments: '',
          statusId: 'IN',
          statusName: ''
        },
        id_not_found: false,
      }
    },
    methods: {
      reset_data() {
        if (this.$route.params.id > 0) {
          this.data_local = JSON.parse(JSON.stringify(this.data));
          this.editing = false;
        } else {
          this.$router.push({name: 'cash_registers'});
        }
      },
      resolutionFiltering: function (e) {
        var searchData = JSON.parse(JSON.stringify(this.resolutions));
        if (e.text == '') {
          e.updateData(searchData);
        } else {
          // var query = new Query().select(['name', 'id']);
          var query = new Query().select(['fullName', 'id']);
          query = (e.text !== '') ? query.where('fullName', 'contains', e.text, true, true) : query;
          e.updateData(searchData, query);
        }
      },
      getData(id) {
        if (id) {
          if (id == 0) {
            this.$vs.loading.close();
            this.loaded = true;
            this.id_not_found = false;
            this.editing = true;
          } else {
            var self = this;
            this.$http.post(deltaPOS_config.default.apiURL + '/sale/cash_register/data', {id: id, context: this.$store.state.AppActiveUser}).then(response => {
              if (response.data.success) {
                self.data = response.data.data;
                self.data_local = JSON.parse(JSON.stringify(response.data.data));
              } else {
                if (id > 0) {
                  this.id_not_found = true;
                }
              }
              self.$vs.loading.close();
              self.loaded = true;
            })
          }
        } else {
          this.$vs.loading.close();
          this.loaded = true;
          if (id == 0) {
            this.id_not_found = false;
          }
          this.editing = true;
        }
      },
      validateForm() {
        var message = '';
        if (!this.data_local.code || this.data_local.code == '') {
          message = 'Debe especificar un número de resolución';
        } else if (!this.data_local.name || this.data_local.name == '') {
          message = 'Debe especificar una descripción';
        } else if (!this.data_local.statusId || this.data_local.statusId == '') {
          message = 'Debe seleccionar un estado';
        } else {
          var status = this.status.filter(item => item.code == this.data_local.statusId);
          if (status.length <= 0) {
            message = 'Estado incorrecto';
          }
        }
        if (message != '') {
          this.$vs.notify({
            title: 'Error al guardar resolución',
            text: message,
            color: 'danger'
          });
        }
        return (message == '');
      },
      save() {
        if (this.validateForm()) {
          this.$vs.loading({
            text: 'Guardando información de caja',
            type: 'point'
          });
          var self = this;
          this.data_local.id = parseInt(this.$route.params.id);
          this.data_local.context = this.$store.state.AppActiveUser;
          this.data_local.createdBy = parseInt(localStorage.getItem(`${deltaPOS_config.default.itemPrefix}UserId`));
          this.$http.post(deltaPOS_config.default.apiURL + '/sale/cash_register/save', this.data_local).then(response => {
            if (response.data.success) {
              self.$vs.notify({
                title: 'Información actualizada',
                text: 'Datos de la caja fueron actualizados correctamente',
                color: 'primary'
              });
              if (self.id == 0) {
                self.$router.push({name: 'resolution', params: {id: response.data.data.id}});
              }
              this.editing = false;
            } else {
              self.$vs.notify({
                title: 'Error al actualizar',
                text: response.data.message,
                color: 'danger'
              });
            }
            this.$vs.loading.close();
          });
        }
      },
      confirmDeleteRecord() {
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: `Confirmar`,
          text: `Se dispone a eliminar caja "${this.data.name}"`,
          accept: this.deleteRecord,
          acceptText: "Delete"
        })
      },
      deleteRecord() {
        this.$vs.loading({
          text: 'Eliminando caja',
          type: 'point'
        });
        var self = this;
        this.$http.post(deltaPOS_config.default.apiURL + '/sale/resolutions/delete', {id: this.id, context: this.$store.state.AppActiveUser}).then(response => {
          if (response.data.success) {
            self.$vs.notify({
              title: 'Información eliminada',
              text: 'Caja fue eliminada correctamente',
              color: 'primary'
            });
            self.$router.push({name: 'cach_registers'});
          } else {
            self.$vs.notify({
              title: 'Error al actualizar',
              text: response.data.message,
              color: 'danger'
            });
          }
          this.editing = false;
          this.$vs.loading.close();
        });
      }
    },

    mounted() {
      this.id = parseInt(this.$route.params.id);
      var self = this;
      if (this.id > 0) {
        this.$vs.loading({
          text: 'Cargando datos de caja',
          type: 'point'
        });
      }
      this.$http
        .post(deltaPOS_config.default.apiURL + '/lists/get_list', {userId: this.$store.state.AppActiveUser.userId, token: this.$store.state.AppActiveUser.token, list: 'ESTADOCAJA'})
        .then(response => {
          if (response.data.success) {
            self.status = response.data.data;
          }
          self.$http
            .post(deltaPOS_config.default.apiURL + '/sale/resolutions/list', {userId: this.$store.state.AppActiveUser.userId, token: this.$store.state.AppActiveUser.token})
            .then(response => {
              if (response.data.success) {
                self.resolutions = response.data.data;
              }
              self.$http
                .post(deltaPOS_config.default.apiURL + '/stock/warehouses/list', {userId: this.$store.state.AppActiveUser.userId, token: this.$store.state.AppActiveUser.token})
                .then(response => {
                  if (response.data.success) {
                    self.warehouses = response.data.data;
                  }
                  self.getData(this.id);
                });
            });
        });
    }
  }
</script>

<style lang="scss">
  @import '../../../../node_modules/@syncfusion/ej2-base/styles/material.css';
  @import '../../../../node_modules/@syncfusion/ej2-buttons/styles/material.css';
  /*@import '../../../../node_modules/@syncfusion/ej2-calendars/styles/material.css';*/
  @import '../../../../node_modules/@syncfusion/ej2-dropdowns/styles/material.css';
  @import '../../../../node_modules/@syncfusion/ej2-inputs/styles/material.css';
  /*@import '../../../../node_modules/@syncfusion/ej2-navigations/styles/material.css';*/
  /*@import '../../../../node_modules/@syncfusion/ej2-popups/styles/material.css';*/
  /*@import '../../../../node_modules/@syncfusion/ej2-splitbuttons/styles/material.css';*/
  /*@import "../../../../node_modules/@syncfusion/ej2-vue-grids/styles/material.css";*/

  .wrapper {
    max-width: 250px;
    margin: 0 auto;
  }

  .e-grid .e-altrow {
    background-color: #fafafa;
  }

  #avatar-col {
    width: 12rem;
  }

  #page-stock-branch-edit {
    table {
      td {
        vertical-align: top;
        min-width: 140px;
        padding-bottom: .4rem;
        word-break: break-all;
      }

      &:not(.permissions-table) {
        td {
          @media screen and (max-width: 370px) {
            display: block;
          }
        }
      }
    }
  }

  @media screen and (min-width: 1201px) and (max-width: 1211px),
  only screen and (min-width: 636px) and (max-width: 991px) {
    #account-info-col-1 {
      width: calc(100% - 12rem) !important;
    }
  }

</style>
